import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_INVOICE_CLIENT_ITEM_RESET   = 'PUT_INVOICE_CLIENT_ITEM_RESET';
export const PUT_INVOICE_CLIENT_ITEM_LOADING = 'PUT_INVOICE_CLIENT_ITEM_LOADING';
export const PUT_INVOICE_CLIENT_ITEM_SUCCESS = 'PUT_INVOICE_CLIENT_ITEM_SUCCESS';
export const PUT_INVOICE_CLIENT_ITEM_REJECT  = 'PUT_INVOICE_CLIENT_ITEM_REJECT';

//* ACTIONS ------------------------------------------------
export const putInvoiceClientItemReset   = () => ({ type: PUT_INVOICE_CLIENT_ITEM_RESET });
export const putInvoiceClientItemLoading = () => ({ type: PUT_INVOICE_CLIENT_ITEM_LOADING });
export const putInvoiceClientItemSuccess = (payload) => ({ type: PUT_INVOICE_CLIENT_ITEM_SUCCESS, payload });
export const putInvoiceClientItemReject  = (payload) => ({ type: PUT_INVOICE_CLIENT_ITEM_REJECT,  payload });

//* REQUEST SERVICE ----------------------------------------
export const putInvoiceClientItemRequest = async (body = {}, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data: body,
    }, getState);
    return request(`/Invoices/web/UpdateInvoicesLine`, options);
};
